import { useTranslation } from 'react-i18next';
import { LabeledValueList } from '@/common/components/LabeledValueList/LabeledValueList';
import { Stack } from '@/common/components/Stack/Stack';
import { IVoucher } from '@/common/integrations/menhir/employee/vouchers/vouchers.types';
import { formatDate } from '@/common/utils/date';
import { StringUtils } from '@/common/utils/string';
import { TaxUtils } from '@/common/utils/tax';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';

interface IProps {
  voucher: IVoucher;
}

export const ChildcareVoucherInfo = ({ voucher }: IProps) => {
  const { t } = useTranslation();

  const voucherDate = formatDate(voucher.issuedAt, { fallback: '---' });

  return (
    <Stack gap="xl">
      <LabeledValueList.Root
        title={t('dashboard.childcare_voucher_info.voucher.title')}
      >
        {voucher.reference ? (
          <LabeledValueList.Item
            label={t('dashboard.childcare_voucher_info.voucher.reference')}
            value={voucher.reference}
          />
        ) : null}
        <LabeledValueList.Item
          label={t('dashboard.childcare_voucher_info.voucher.amount')}
          value={MoneyUtils.moneyToString(voucher.amount)}
        />
        <LabeledValueList.Item
          label={t('dashboard.childcare_voucher_info.voucher.date')}
          value={voucherDate}
        />
      </LabeledValueList.Root>

      <LabeledValueList.Root
        title={t('dashboard.childcare_voucher_info.child.title')}
      >
        <LabeledValueList.Item
          label={t('dashboard.childcare_voucher_info.child.full_name')}
          value={voucher.beneficiary.fullName}
        />

        <LabeledValueList.Item
          label={t('dashboard.childcare_voucher_info.child.tax_number')}
          value={TaxUtils.formatTaxId(voucher.beneficiary.taxId, '---')}
        />
      </LabeledValueList.Root>
      <LabeledValueList.Root
        title={t('dashboard.childcare_voucher_info.school.title')}
      >
        <LabeledValueList.Item
          label={t('dashboard.childcare_voucher_info.school.name')}
          value={voucher.establishment.name}
        />

        <LabeledValueList.Item
          label={t('dashboard.childcare_voucher_info.school.address')}
          value={StringUtils.buildAddressString(voucher.establishment.address)}
        />
      </LabeledValueList.Root>
    </Stack>
  );
};
